import { render, staticRenderFns } from "./flaContractFormComments.vue?vue&type=template&id=4a1f8cd5&"
import script from "./flaContractFormComments.vue?vue&type=script&lang=js&"
export * from "./flaContractFormComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports